<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright">
<h1><a id="page_0002"></a><b><i>Preaching Hebrews</i></b></h1>
<div class="image">
<img alt="i_Image2" src="images/logo.jpg"/>
</div>
<p>ACU Box 29138<br/>Abilene, TX 79699<br/><a href="http://www.acu.edu/acupress" target="_blank">www.acu.edu/acupress</a></p>
<p>Cover Design and Typesetting by Sarah Bales</p>
<p>Copyright © 2003</p>
<p>David Fleer and Dave Bland, editors</p>
<p>All rights reserved. Except as provided in the Copyright Act of 1976, no part of this book may be reproduced, stored in a retrieval system, or transcribed, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise, without prior written permission from the Abilene Christian University Press.</p>
<p>Printed in the United States of America</p>
<p>ISBN 0-89112-138-2</p>
<p>Library of Congress Card Number: 2003105898</p>
<p>Second Edition</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780891128793_Part03.vue?30d3165e